import script from "./CreateSurvey.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSurvey.vue?vue&type=script&setup=true&lang=js"

import "./CreateSurvey.vue?vue&type=style&index=0&id=cadc7aae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cadc7aae"]])

export default __exports__